// extracted by mini-css-extract-plugin
export default {"bigTitle":"BigTitle_bigTitle__C+7bC"};